"use client";
import { RouteError } from "@/components/RouteError";
import { commissionsHref } from "@/lib/commissions/routes";

export default function CommissionsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteError
      error={error}
      reset={reset}
      label="COMMISSIONS ERROR"
      backHref={commissionsHref.creators}
      backLabel="Back to Commissions"
    />
  );
}
